import { IQuebecObstetricalFileFormPage } from "../IQuebecObstetricalFileFormPage";
import { Signature } from "../Signature";
import { CurrentPregnancy } from "./CurrentPregnancy";
import { FamilyAntecedents } from "./FamilyAntecedents";
import { LifestyleAndEnvironment } from "./LifestyleAndEnvironment";
import { MenstrualHistory } from "./MenstrualHistory";
import { PersonalAntecedents } from "./PersonalAntecedents";
import { PreviousPregnancies } from "./PreviousPregnancies";
import { SpousalInfo } from "./SpousalInfo";

class QuebecObstetricalFileFormPageOne implements IQuebecObstetricalFileFormPage {
    public Summary: string;
    public Signature: Signature;
    public IsDownSyndromeInformationShared: boolean;
    public SpousalInfo: SpousalInfo;
    public FamilyAntecedents: FamilyAntecedents;
    public PersonalAntecedents: PersonalAntecedents;
    public MenstrualHistory: MenstrualHistory;
    public PreviousPregnancies: PreviousPregnancies;
    public CurrentPregnancy: CurrentPregnancy;
    public LifestyleAndEnvironment: LifestyleAndEnvironment;

    constructor(fields?: Partial<QuebecObstetricalFileFormPageOne>) {
        Object.assign(this, fields);

        this.SpousalInfo = new SpousalInfo(fields?.SpousalInfo);
        this.FamilyAntecedents = new FamilyAntecedents(fields?.FamilyAntecedents);
        this.PersonalAntecedents = new PersonalAntecedents(fields?.PersonalAntecedents);
        this.MenstrualHistory = new MenstrualHistory(fields?.MenstrualHistory);
        this.PreviousPregnancies = new PreviousPregnancies(fields?.PreviousPregnancies);
        this.CurrentPregnancy = new CurrentPregnancy(fields?.CurrentPregnancy);
        this.LifestyleAndEnvironment = new LifestyleAndEnvironment(fields?.LifestyleAndEnvironment);
        this.Signature = new Signature(fields?.Signature);
    }
}

export { QuebecObstetricalFileFormPageOne };
